import useTrees from "../../../Hooks/useTrees";
import useUIBp from "../../../Hooks/useUIBoilerplate";
import useURLQuery from "../../../Hooks/useURLQuery";
import { UIactions } from "../../../store/slices/UI";
import BasicLayout from "../../UI/BasicLayout/BasicLayout";
import { resetScrollId } from "../../UI/BasicLayout/Components/Core/Core";
import MessageCard from "./MessageCard/MessageCard";
import PlusActions, { plusActionsGrid } from "./PlusActions/PlusActions";

const Core = (props) => {
  const { messages, done, working, error, workerId } = props;
  const { dispatch } = useUIBp();
  const { teamId, channelId } = useURLQuery();
  const trees = useTrees() ?? {};
  const tree = trees[`teams-${teamId}`] ?? [];

  const teamNode = tree[0];
  const channelNode = tree.find((n) => n && n.id === channelId);

  let header = "";
  if (teamNode && channelNode) {
    header = `${teamNode.displayName} / ${channelNode.displayName}`;
  } else if (teamNode) {
    header = teamNode.displayName;
  }

  const plusActions = <PlusActions />;
  const elements = messages.map((data, idx) => (
    <MessageCard key={data.id ?? idx} {...data} />
  ));

  const coreData = {
    working,
    error: {
      workerId,
      error,
      UIText: {
        "es-CL": { message: "Error al cargar los mensajes: " + error },
        "en-US": { message: "Error loading messages: " + error },
      },
    },
    empty: {
      isEmpty: !messages.length && done && !error,
      UIText: {
        "es-CL": { message: "No hay mensajes en este canal" },
        "en-US": { message: "There are no messages in this channel" },
      },
    },
    done,
    elements,
  };

  return (
    <BasicLayout
      noRecursive
      {...{
        plusActions,
        plusActionsGrid,
        header,
        filterSize: "grow",
        advancedFilter: true,
        advancedFilterModal: "advanced-teams-filter",
        coreData,
        onPaginationChange: () => {
          dispatch(UIactions.setValue({ id: resetScrollId, value: true }));
        },
      }}
    />
  );
};

export default Core;
